<button type="button" (click)="open(content)" ngbTooltip="Show filter & sort options" class="btn btn-lg btn-primary">
  <i class="bi bi-gear fw-bold me-2"></i> Options
</button>

<ng-template #content let-offcanvas>
  <div class="offcanvas-header pt-4">
    <h3 class="fw-bold mb-0 mt-2 fs-6">
      Filter & Sort Options
    </h3>
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <hr class="mb-1">
  <div class="offcanvas-body">
    <div *ngIf="showFilter" class="row mb-4">
      <label class="form-label fw-semibold fs-8">Sort Field</label>
      <app-custom-select ngbAutofocus [(ngModel)]="sortField" (ngModelChange)="changeSort()" [title]="'Select Option'"
        [options]="getSortColumns()" >
      </app-custom-select>
    </div>
    <div class="row mb-4">
      <label class="form-label fw-semibold fs-8">Sort Direction</label>
      <app-custom-select [(ngModel)]="sortDirection" (ngModelChange)="changeSort()" [title]="'Select Option'"
        [options]="sortDirections">
      </app-custom-select>
    </div>
    <hr class="text-gray-600">
    <div class="d-flex">
      <button type="button" class="btn btn-lg btn-dark ms-2" (click)="offcanvas.close('Close click')"> <i
          class="bi bi-check-all me-2 fw-bold"></i> Apply Filters</button>
    </div>

    <div class="pt-5 mt-3">
      <h3 class="fw-bold mb-0 mt-2 fs-6">
        Export Data
      </h3>
    </div>
    <hr class="my-3">
    <div class="d-flex">
      <button type="button" class="btn btn-lg btn-light" (click)="export('xlsx')"> <i
          class="bi bi-file-spreadsheet me-2 fw-bold"></i> Export Excel</button>
      <button type="button" class="btn btn-lg btn-light ms-2" (click)="export('pdf')"> <i
          class="bi bi-file-pdf me-2 fw-bold"></i> Export PDF</button>
    </div>
  </div>
</ng-template>
